import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import TreatmentPage, { ServicesIndex } from "./pages/TreatmentPage";
import { Toaster } from "./components/ui/toaster";
import { LanguageProvider } from "./i18n/LanguageContext";
import { AuthProvider } from "./admin/AuthContext";
import { AssetsProvider } from "./assets/AssetsContext";
import AdminLogin from "./admin/AdminLogin";
import AdminDashboard from "./admin/AdminDashboard";
import VisitTracker from "./components/VisitTracker";
import HashScroller from "./components/HashScroller";
import WhatsAppFloat from "./components/WhatsAppFloat";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <AssetsProvider>
          <AuthProvider>
            <BrowserRouter>
              <VisitTracker />
              <HashScroller />
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/services" element={<ServicesIndex />} />
                <Route path="/treatments/:slug" element={<TreatmentPage />} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<AdminDashboard />} />
              </Routes>
              <WhatsAppFloat />
            </BrowserRouter>
            <Toaster />
          </AuthProvider>
        </AssetsProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
